import { StyledProps, React, withStyles, Fragment} from '@api';
import { Snackbar, SnackbarContent, IconButton } from '@material-ui/core'
import { Close, Done, ErrorOutline } from '@material-ui/icons'
import {ui} from '@stores'

const styles = theme => ({
  success: {
    backgroundColor: '#4caf50'
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  snackTitle: {
    fontSize: 16,
    fontWeight: 'normal'
  },
  snackMessage: {
    fontSize: 14,
    fontWeight: 'normal'
  },
  snackbarContent: {
    display: 'flex'
  },
  messageContent: {
    flex: 1
  },
  snackbarIcon: {
    cursor: 'default',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
})

interface MyProps extends StyledProps {
  open?: boolean
  onClose?: (e) => void,
  title?: string,
  message: any,
  messageType?: string,
  vertical?: 'top' | 'bottom',
  horizontal?: 'center' | 'left' | 'right'
}

@(withStyles as any)(styles)
export class SuccessBar extends React.Component <MyProps> {
  render() {
    const {classes, open, onClose, title, message, messageType, vertical, horizontal} = this.props
    return (
      <Snackbar
        anchorOrigin={{
          vertical:   vertical || 'top',
          horizontal: horizontal || 'right'
        }}
        open={open}
        autoHideDuration={ui.settings.AUTOHIDE_SNACKBAR_DURATION}
        onClose={onClose}
      >
        <SnackbarContent
          className={classes[messageType || 'success']}
          aria-describedby='product-snackbar'
          message={
            <div className={classes.snackbarContent}>
              <IconButton className={classes.snackbarIcon} color={'inherit'}>
                {messageType === 'error' ? <ErrorOutline/> : <Done/>}
              </IconButton>
              <div className={classes.messageContent}>
                <div id='client-snackbar' className={classes.snackTitle}>
                  {title}
                </div>
                <div className={classes.snackMessage}>
                  {message}
                </div>
              </div>
            </div>
          }
          action={<Fragment>
            <IconButton
              key='product-close'
              aria-label='product-close'
              color='inherit'
              onClick={onClose}
            >
              <Close className={classes.icon}/>
            </IconButton>
          </Fragment>}
        />
      </Snackbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/SuccessBar.tsx